import React from "react";
import DonutChart from "react-donut-chart";

const DonutChartWithLabel = ({ data, totalStd }) => {
  const colors = [
    "#4caf50",
    "#f44336",
    "#00bcd4",
    "#9c27b0",
    "#673ab7",
    "#209444",
    "#1C75BC",
    "#e91e63",
    "#3f51b5",
    "#2196f3",
    "#03a9f4",
    "#009688",
    "#8bc34a",
    "#cddc39",
    "#ffeb3b",
    "#ffc107",
    "#ff9800",
    "#ff5722",
    "#795548",
  ];

  return (
    <>
      <div className="flex justify-center my-1">
        <DonutChart
          width="250"
          height="250"
          innerRadius={0.5}
          strokeColor="#e0e0e0"
          legend={false}
          colors={colors}
          emptyColor="#ECECEC"
          data={data}
          onClick={(item, toggled) => {
            toggled && console.log(item);
          }}
        />
      </div>

      {/* legend */}
      <div>
        {data.map((demo, i) => (
          <div key={i} className="flex m-1 justify-between ">
            <div className="flex items-center">
              <div
                style={{ backgroundColor: colors[i] }}
                className="h-3 w-3 mr-2"
              ></div>
              <span>{demo.label ? demo.label : "Other"}</span>
            </div>
            <span>{demo.value ? demo.value : "No Data"}</span>
          </div>
        ))}
        {totalStd && (
          <div className="flex m-1 justify-between ">
            <div className="flex items-center">
              <div
                style={{ backgroundColor: "#607d8b" }}
                className="h-3 w-3 mr-2"
              ></div>
              <span>Total Student</span>
            </div>
            <span>{totalStd}</span>
          </div>
        )}
      </div>
    </>
  );
};

export default DonutChartWithLabel;
